import { inject, Pipe, PipeTransform } from '@angular/core';

import { ThemesService } from './themes.service';

@Pipe({
  name: 'idealsThemeClass',
})
export class ThemeClassPipe implements PipeTransform {
  readonly #themesService = inject(ThemesService);

  transform(color: string): string {
    return this.#themesService.themeNameToClass(this.#themesService.colorToThemeName(color));
  }
}
